import InspectorPerformanceSections from 'app/main/agency/inspector-profile/performance-sections/PerformanceSections';
import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { cloneDeep } from 'lodash-es';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const PerformanceDashboard = lazy(
  () =>
    import('../../../../main/agency/inspector-profile/performance-sections/performance-dashboard/PerformanceDashboard')
);

const QaReportPage = lazy(
  () => import('../../../../main/agency/inspector-profile/performance-sections/qa-report-page/QaReportPage')
);

const CtpRecordsPage = lazy(
  () => import('app/main/agency/inspector-profile/performance-sections/ctp-records-page/CtpRecordsPage')
);

export const inspectorPerformanceRoutes: RouteObject[] = [
  {
    path: '',
    element: <InspectorPerformanceSections />,
    children: [
      {
        path: '',
        element: <Navigate replace to="dashboard" />,
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PerformanceDashboard />
          </Suspense>
        ),
      },
      {
        path: 'qa-report',
        element: (
          <Suspense fallback={<DataLoader />}>
            <QaReportPage />
          </Suspense>
        ),
      },
      {
        path: 'ctp-records',
        element: (
          <Suspense fallback={<DataLoader />}>
            <CtpRecordsPage />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
];

export const getInspectorPerformanceRoutes = (excludes: string[]): RouteObject[] => {
  const routes = cloneDeep(inspectorPerformanceRoutes);
  const result =
    routes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  routes[0].children = result;
  return routes;
};
